import React from "react";

function Education({ stateObj, setStateObj, UpdateProfile, setCurrentDiv }) {
  return (
    <div className="row">
      <div className="col-sm-6 col-md-6">
        <div className="form-group">
          <label className="form-label">
          Post your requirement / Post your Service:
          <small style={{ float: "right" }}>
              {stateObj.highestdegree?.length || 0} / 2000
            </small>
          </label>
          <input
            type="text"
            class="form-control"
            placeholder="Enter your requirement / service"
            onChange={(e) =>{
              if (e.target.value.length <= 2000)
              setStateObj({ ...stateObj, highestdegree: e.target.value })
            }}
            value={stateObj.highestdegree}
          ></input>
        </div>
      </div>
      <div className="col-sm-6 col-md-6">
        <div className="form-group">
          <label className="form-label" htmlFor="course">
            Qualification:
          </label>
          <input
            type="text"
            class="form-control"
            placeholder="Qualification"
            onChange={(e) =>
              setStateObj({ ...stateObj, course: e.target.value })
            }
            value={stateObj.course}
          ></input>
        </div>
      </div>
      <div className="col-sm-6 col-md-6">
        <div className="form-group">
          <label className="form-label" htmlFor="coursetype">
          Target Geographic locations:
          </label>
          <select
            className="form-control"
            name="coursetype"
            id="coursetype"
            onChange={(e) =>
              setStateObj({ ...stateObj, coursetype: e.target.value })
            }
            value={stateObj.coursetype}
          >
            <option value="">-- Select --</option>
            <option value="Domestic">Domestic</option>
            <option value="Domestic and International">Domestic and International</option>
          </select>
        </div>
      </div>
      <div className="col-sm-6 col-md-6">
        <div className="form-group">
          <label className="form-label" htmlFor="startingyear">Languages known:</label>
          <input
            className="form-control"
            type="text"
            name="startingyear"
            id="startingyear"
            placeholder="e.g., English, French, Spanish, etc..."
            onChange={(e) =>
              setStateObj({ ...stateObj, startedyear: e.target.value })
            }
            value={stateObj.startedyear}
          />
        </div>
      </div>
      <div className="col-sm-6 col-md-6">
        <div className="form-group">
          <label className="form-label" htmlFor="passingyear">Portfolio:</label>
          <input
            className="form-control"
            type="text"
            name="passingyear"
            id="passingyear"
            onChange={(e) =>
              setStateObj({ ...stateObj, passedyear: e.target.value })
            }
            value={stateObj.passedyear}
          />
        </div>
      </div>
      <div className="col-sm-6 col-md-6">
        <div className="form-group">
          <label className="form-label" htmlFor="passingyear">Blogs / Reels:</label>
          <input
            className="form-control"
            type="text"
            name="cgpa"
            id="cgpa"
            placeholder="Blogs / Reels"
            onChange={(e) => setStateObj({ ...stateObj, cgpa: e.target.value })}
            value={stateObj.cgpa}
          />
        </div>
      </div>
      <div className="col-sm-6 col-md-6">
        <div className="form-group">
          <label className="form-label" htmlFor="passingyear">Relevant Certifications:</label>
          <input
            className="form-control"
            type="text"
            placeholder={
              stateObj.activestatus !== "True"
                ? "Subscribe To Enter"
                : "Certifications"
            }
            readOnly={stateObj.activestatus !== "True"}
            onChange={(e) => {
              if (stateObj.activestatus === "True")
                setStateObj({ ...stateObj, certifications: e.target.value });
            }}
            value={stateObj.certifications}
          />
        </div>
      </div>
      <div className="col-sm-6 col-md-6">
        <div className="form-group">
          <label className="form-label" htmlFor="passingyear">Ongoing Learnings</label>
          <input
            className="form-control"
            type="text"
            placeholder={
              stateObj.activestatus !== "True"
                ? "Subscribe To Enter"
                : "Learnings"
            }
            readOnly={stateObj.activestatus !== "True"}
            onChange={(e) => {
              if (stateObj.activestatus === "True")
                setStateObj({ ...stateObj, learnings: e.target.value });
            }}
            value={stateObj.learnings}
          />
        </div>
      </div>
      <div className="form-group">
        <button
          className="btn btn-primary "
          onClick={() => {
            UpdateProfile();
            setCurrentDiv("employment");
          }}
        >
          Submit
        </button>
      </div>
    </div>
  );
}

export default Education;
